import React from 'react';
import { Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react';

/**
 * The common section card of the event page tabs: outline card + small heading (+ optional actions
 * on the right of the heading). Every tab groups its content with it, so they all look alike.
 */
const SectionCard: React.FC<{
  title: string;
  actions?: React.ReactNode;
  /** Remove the body padding (full-width tables). */
  flush?: boolean;
  testId?: string;
  children: React.ReactNode;
}> = ({ title, actions, flush = false, testId, children }) => (
  <Card variant="outline" data-testid={testId ?? 'section-card'}>
    <CardHeader pb={0}>
      <Flex align="center" justify="space-between" gap={3} wrap="wrap">
        <Heading size="sm">{title}</Heading>
        {actions}
      </Flex>
    </CardHeader>
    <CardBody p={flush ? 0 : undefined} pt={flush ? 3 : undefined}>{children}</CardBody>
  </Card>
);

export default SectionCard;
